/**
 * /settings/tax-codes/new — Create a tax code (G_ACC3).
 *
 * Gated behind RequireFeature("accounting") on the backend. The frontend
 * shell checks isHrAdmin (company_admin | hr_manager) to show this link;
 * the backend is the real boundary.
 */

import { createFileRoute } from "@tanstack/react-router";
import { useHrRoles } from "@/components/hr/use-hr-roles";
import { SettingsPageHeader } from "@/components/shared/settings-page-header";
import { SettingsShell } from "@/components/shared/settings-shell";
import { SETTINGS_GROUPS } from "@/lib/settings-nav";
import { TaxCodeForm } from "@/components/accounting/tax-code-form";
import { Card, CardContent } from "@/components/ui/card";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/alert";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/settings/tax-codes/new",
)({
  component: NewTaxCodeRoute,
});

function NewTaxCodeRoute() {
  const { isHrAdmin } = useHrRoles();

  return (
    <>
      <SettingsPageHeader />
      <SettingsShell groups={SETTINGS_GROUPS}>
        <div className="space-y-6">
          <div>
            <h2 className="text-lg font-semibold">Add tax code</h2>
            <p className="text-sm text-muted-foreground">
              Create a new GST or TDS rate code for this company.
            </p>
          </div>

          {!isHrAdmin ? (
            <Alert>
              <AlertTitle>Access restricted</AlertTitle>
              <AlertDescription>
                Only HR managers and company admins can create tax codes.
              </AlertDescription>
            </Alert>
          ) : (
            <Card className="max-w-3xl">
              <CardContent className="pt-6">
                <TaxCodeForm />
              </CardContent>
            </Card>
          )}
        </div>
      </SettingsShell>
    </>
  );
}
